import React, { useMemo } from 'react';

import isNumber from 'lodash/isNumber';
import { useTranslation } from 'react-i18next';

import { GenerationIcon } from '@pkg/components/GenerationIcon';

import config from '@app/config';
import { getGlowLevel, type GlowLevelTypes } from '@app/helpers';

import './RhythmScoreBadge.scss';

interface RhythmScoreBadgeProps {
    generation?: number;
    score: number;
    classes?: string;
    badgeStyle?: 'bare' | 'pill';
    hasPadding?: boolean;
}

export const RhythmScoreBadge = ({
    generation,
    score,
    classes = '',
    badgeStyle = 'pill',
    hasPadding = true,
}: RhythmScoreBadgeProps) => {
    const { t } = useTranslation(['common']);

    const classNames = useMemo(() => {
        const variant: GlowLevelTypes = getGlowLevel(score);
        let classNames = 'yat-rhythm-score-badge';
        if (hasPadding) classNames += ' has-padding';
        if (variant) classNames += ` yat-rhythm-score-badge--${variant}`;
        classNames += ` yat-rhythm-score-badge--${badgeStyle}`;
        if (classes) classNames += ` ${classes}`;

        return classNames;
    }, [score, classes, hasPadding, badgeStyle]);

    return (
        <div className={classNames}>
            <div className="yat-rhythm-score-badge__circle" />
            {(config.yatGen1Start < new Date() || config.yatGen2Start < new Date()) && isNumber(generation) && (
                <GenerationIcon generation={generation} classes="yat-rhythm-score-badge__generation" />
            )}
            <span className="yat-rhythm-score-badge__sr-text">{t('rhythm_score_of')}</span>
            <span className="yat-rhythm-score-badge__score">
                <span>{score}</span>
            </span>
        </div>
    );
};
